// import api from "@/services/api";
// import apiEndpoints from "@/services/apiEndpoints";

const getDefaultState = () => {
  return {
    addressRegistrationInfo: {},
  };
};

const state = getDefaultState();

const mutations = {
  SAVE_ADDRESS: (state, addressRegistrationInfo) => {
    state.addressRegistrationInfo = addressRegistrationInfo;
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions,
};
